<template>
  <hm-content title="">
    <div class="table-panel flex flex-between item-center">
      <div class="title">商品复购分析报表</div>
      <div>
        <el-date-picker
          v-model="searchCondition.createTimeArry"
          :default-time="['00:00:00', '23:59:59']"
          type="datetimerange"
          align="right"
          size="small"
          class="mr10"
          unlink-panels
          value-format="yyyy-MM-dd HH:mm:ss"
          range-separator="至"
          start-placeholder="查询商品复购率开始日期"
          end-placeholder="查询商品复购率结束日期"
          :picker-options="pickerOptions"
        >
        </el-date-picker>
        <el-input
          type="text"
          class="mr10"
          v-model.trim="searchCondition.spuName"
          clearable
          placeholder="请输入商品名称"
          size="small"
        ></el-input>
        <el-select
          size="small"
          class="mr10"
          style="width:230px"
          v-model="searchCondition.planId"
          filterable
        >
          <el-option label="全部复购提醒计划" value=""></el-option>
          <el-option :label="v.planName" :value="v.id" v-for="(v,i) in purchasePlanList" :key="i"></el-option>
        </el-select>
        <el-button type="primary" size="small" @click="search">查询</el-button>
      </div>
    </div>
    <div>
      <el-table
        stripe
        ref="btable"
        :data="list"
        style="width: 100%"
        id="table"
        size="small"
        @sort-change="sortChange"
        border
        :default-sort="{ prop: 'num', order: 'desc' }"
      >
        <el-table-column
          type="index"
          label="序号"
          :index="(index) => index + (currentPage - 1) * pageSize + 1"
        ></el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="spuName"
          label="商品名称"
          width="500"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="specIdGroupName"
          label="商品规格"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="noticeNum"
          label="复购提醒人数"
          sortable
        ></el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="payNum"
          label="复购付款人数"
          sortable
        >
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="payPrice"
          label="复购金额"
          sortable
        >
          <template slot-scope="scope">
            ￥{{scope.row.payPrice? toPriceNum(scope.row.payPrice.toFixed(2)):0 }}
          </template>
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="proportion"
          label="复购率"
        ></el-table-column>
      </el-table>
      <div class="hm-pagination">
        <el-pagination
          background
          :total="total"
          @current-change="paging"
          @size-change="handleSizeChange"
          layout="total, sizes, prev, pager, next, jumper"
          :current-page="currentPage"
        ></el-pagination>
      </div>
    </div>
  </hm-content>
</template>

<script>
import moment from "moment";
export default {
  components: {},
  data() {
    return {
      pickerOptions: {
        shortcuts: [
          {
            text: "最近一周",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "最近一个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "最近三个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit("pick", [start, end]);
            }
          }
        ]
      },
      total: 0,
      list: [],
      pageSize: 10,
      currentPage: 1,
      searchCondition: {
        planId: "",
        createTimeArry: []
      },
      purchasePlanList: [],
      sort: {}
    };
  },
  computed: {},
  watch: {},
  created() {},
  mounted() {
    this.searchCondition.createTimeArry = [
      moment(new Date())
        .add(-7, "days")
        .format("YYYY-MM-DD") + " 00:00:00",
      moment().format("YYYY-MM-DD") + " 23:59:59"
    ];
    this.queryList();
    this.purchasePlanAllList();
  },
  methods: {
    sortChange(sort) {
      this.sort = sort;
      this.queryList();
    },
    async purchasePlanAllList() {
      const params = {
        pageSize: 99999,
        pageNo: 1
      };
      // const searchCondition = JSON.parse(JSON.stringify(this.searchCondition));
      // Object.assign(params, searchCondition);
      const { code, result } = await this.$store.dispatch(
        "queryStoreRepurchasePlanInfoList",
        params
      );
      if (code === "0") {
        const { records } = result;
        this.purchasePlanList = records;
      }
    },
    toPriceNum(num) {
      if (isNaN(num)) {
        num = 0;
      }
      return (
        num &&
        num.toString().replace(/\d+/, function(s) {
          return s.replace(/(\d)(?=(\d{3})+$)/g, "$1,");
        })
      );
    },
    async queryList() {
      const params = {
        pageSize: this.pageSize,
        pageNo: this.currentPage,
        orderByType: this.sort.prop
      };
      const searchCondition = JSON.parse(JSON.stringify(this.searchCondition));

      if (this.sort.order === "descending") {
        searchCondition.orderByValue = "desc";
      } else if (this.sort.order === "ascending") {
        searchCondition.orderByValue = "asc";
      }
      searchCondition.queryStartTime =
        this.searchCondition.createTimeArry &&
        this.searchCondition.createTimeArry.length > 0
          ? this.searchCondition.createTimeArry[0]
          : null;
      searchCondition.queryEndTime =
        this.searchCondition.createTimeArry &&
        this.searchCondition.createTimeArry.length > 0
          ? this.searchCondition.createTimeArry[1]
          : null;
      Object.assign(params, searchCondition);
      const { code, result } = await this.$store.dispatch(
        "queryRepurchaseSkuAnalyse",
        params
      );
      if (code === "0") {
        const { total, records } = result;
        records.forEach(v => {
          v.proportion = v.totalNoticeNum
            ? ((v.payNum / v.noticeNum) * 100).toFixed(2) + "%"
            : "0%";
        });
        this.list = records;
        this.total = total;
      }
    },
    paging(page) {
      this.currentPage = page;
      this.queryList();
    },
    handleSizeChange(size) {
      this.currentPage = 1;
      this.pageSize = size;
      this.queryList();
    },
    search() {
      this.currentPage = 1;
      this.queryList();
    }
  }
};
</script>
<style lang='scss' scoped>
.title {
  color: #222222;
  font-weight: bold;
  margin-bottom: 18px;
  &::before {
    display: inline-block;
    margin-right: 5px;
    content: "";
    width: 4px;
    height: 14px;
    background: #e50065;
    border-top-left-radius: 30px;
    border-bottom-right-radius: 30px;
  }
}
</style>
